<ng-template #menuTemplate>
  <div class="tw-menu" (click)="handleClick()" [@transformMenu]="animationState">
    <ng-content></ng-content>
  </div>
</ng-template>
